var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcArrowDownCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 12.8502C9.82075 12.8502 9.64155 12.7818 9.50492 12.6452L5.20514 8.34536C4.93162 8.07184 4.93162 7.62837 5.20514 7.35496C5.47855 7.08155 5.92193 7.08155 6.19548 7.35496L9.99997 11.1597L13.8045 7.35509C14.078 7.08168 14.5213 7.08168 14.7947 7.35509C15.0684 7.6285 15.0684 8.07197 14.7947 8.3455L10.495 12.6453C10.3583 12.7819 10.1791 12.8502 9.99997 12.8502Z",
    fill: "#3F9BC0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDownCircle);
export default __webpack_public_path__ + "static/media/ic-arrow-down-circle.3be1bb8897696d84eef32da2e2a3b32e.svg";
export { ForwardRef as ReactComponent };